import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getCities, getStates } from '_/modules/utils/actions'
import { getCitiesOptions, getStatesOptions } from '_/modules/utils/selectors'
import {
  getInspectionBudgetResolutionMaterialUnids,
  getInspectionTradesmen,
} from '_/modules/inspectionBudget/actions'
import { getInspectionBudgetResolutionMaterialUnidsSelector } from '_/modules/inspectionBudget/selector'
import { getServices } from '_/modules/service-orders/actions'

const INSPECTION_TRADESMEN_PARAMS = {
  isActive: true,
  orderBy: 'name',
  pageSize: 'none',
}

const SERVICES_PARAMS = {
  orderBy: 'external_id',
}

const pendingCatalogRequests = {}

function fetchCatalogOnce(key, request) {
  if (!pendingCatalogRequests[key]) {
    const pendingRequest = request().finally(() => {
      if (pendingCatalogRequests[key] === pendingRequest) {
        pendingCatalogRequests[key] = null
      }
    })
    pendingCatalogRequests[key] = pendingRequest
  }

  return pendingCatalogRequests[key]
}

export function useInspectionBudgetCatalogs() {
  const dispatch = useDispatch()
  const didRequestCatalogsRef = useRef(false)
  const citiesOptions = useSelector(getCitiesOptions)
  const stateOptions = useSelector(getStatesOptions)
  const materialUnids = useSelector(getInspectionBudgetResolutionMaterialUnidsSelector)

  const hasCities = !!citiesOptions?.length
  const hasStates = !!stateOptions?.length
  const hasMaterialUnids = !!materialUnids

  useEffect(() => {
    if (didRequestCatalogsRef.current) return

    didRequestCatalogsRef.current = true

    if (!hasStates) {
      fetchCatalogOnce('states', () => dispatch(getStates()))
    }

    if (!hasCities) {
      fetchCatalogOnce('cities', () => dispatch(getCities()))
    }

    fetchCatalogOnce('inspectionTradesmen', () =>
      dispatch(getInspectionTradesmen(INSPECTION_TRADESMEN_PARAMS))
    )

    fetchCatalogOnce('services', () => dispatch(getServices(SERVICES_PARAMS)))

    if (!hasMaterialUnids) {
      fetchCatalogOnce('materialUnids', () =>
        dispatch(getInspectionBudgetResolutionMaterialUnids())
      )
    }
  }, [dispatch, hasCities, hasMaterialUnids, hasStates])
}
